var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wind-hazard-getting-started"}},[_c('the-top-bar',{attrs:{"showUser":""}}),_c('div',{staticClass:"row"},[_c('info-cards',{attrs:{"data-info-cards":_vm.infoCardsData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }